import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ENV } from "@app/env";
import { catchError, retry, switchMap, tap } from "rxjs/operators";
import { Utilities } from "./utilities";
import { of } from "rxjs/observable/of";

export const _TRACKING_ENTITIES = {
  agenda: "agenda",
  staff: "staff",
  news: "news",
  event: "event",
  advertising: "advertising",
  client: "client",
  countdown: "countdown",
  coupon: "coupon",
  embed: "embed",
  employee: "employee",
  events: "events",
  gallery: "gallery",
  plan_my_day: "plan_my_day",
  product: "product",
  question: "question",
  services: "services",
  reserves: "reserves",
  stand: "stand",
  store: "store",
  ticket: "ticket",
  userpqr: "userpqr"
}

@Injectable()
export class TrackingProvider {

  constructor(
    private http: HttpClient,
    private utilities: Utilities,
  ) { }

  public trackEntity(entityType: string, entityId: string, clientId: string, eventId: string, payload: any, message = "ETL Tracking") {
    const entity = {
      clientId,
      entityId,
      eventId,
      entityType,
      payload,
    };
    return this.http.post(`${ENV.etl_url}/etl/record`, entity)
      .pipe(
        retry(1),
        tap((res) => res ? this.utilities.consoleDecorator(`${message}: `, entity, "purple") : null),
        catchError((err) => [this.utilities.consoleDecorator("Error ETL tracking: ", err, "purple")]))
  }

  public trackEntityPromise(entityType: string, entityId: string, clientId: string, eventId: string, payload: any, message = "ETL Tracking"): Promise<any> {
    const entity = {
      clientId,
      entityId,
      eventId,
      entityType,
      payload,
    };
    return this.http.post(`${ENV.etl_url}/etl/record`, entity)
      .pipe(
        retry(1),
        tap((res) => res ? this.utilities.consoleDecorator(`${message}: `, entity, "purple") : null),
        catchError((err) => [this.utilities.consoleDecorator("Error ETL tracking: ", err, "purple")]),
      ).toPromise();
  }
}



// WEBPACK FOOTER //
// ./src/providers/tracking.ts